import "core-js/modules/esnext.global-this.js";
import { url } from '../url.mjs';
var tempAnchor;
function determineCrossOrigin(url$1) {
  var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis.location;
  if (url$1.startsWith("data:")) {
    return "";
  }
  loc = loc || globalThis.location;
  if (!tempAnchor) {
    tempAnchor = document.createElement("a");
  }
  tempAnchor.href = url$1;
  var parsedUrl = url.parse(tempAnchor.href);
  var samePort = !parsedUrl.port && loc.port === "" || parsedUrl.port === loc.port;
  if (parsedUrl.hostname !== loc.hostname || !samePort || parsedUrl.protocol !== loc.protocol) {
    return "anonymous";
  }
  return "";
}
export { determineCrossOrigin };